import { type CustomDateProps, useGridDate } from "ag-grid-react"
import { useState } from "react"
import { DatePicker } from "~/components/design-system/components"

// AG Grid's date filter uses local midnight, as its built-in input did; DatePicker emits UTC
const utcDayToLocalMidnight = (date: Date) =>
  new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())

// The browser input had no bounds; DatePicker defaults to today ±5 years, too narrow for
// ERP placeholders (1900, 2099) and old records
const MIN_DATE = new Date(1900, 0, 1)
const MAX_DATE = new Date(2100, 11, 31)

/** AG Grid `dateComponent` for date column filters, replacing the browser's native date input. */
export default function DateFilterInput({ date, onDateChange }: CustomDateProps) {
  const [disabled, setDisabled] = useState(false)
  useGridDate({ setDisabled })

  return (
    <DatePicker
      value={date ?? undefined}
      onChange={(picked) => onDateChange(picked ? utcDayToLocalMidnight(picked) : null)}
      disabled={disabled}
      minDate={MIN_DATE}
      maxDate={MAX_DATE}
      clearable
      fullWidth
      insideGridPopup
    />
  )
}
